import React, { Component } from 'react';
import PageTitle from '../components/PageTitle';
import Event from '../components/Event';
import concerts from '../data/concerts.json';
import OnPageLoaded from '../utils/onpageloaded';
import { Link } from 'react-router-dom';
//import WOW from 'wowjs';

import '../css/concerts.css'

class Concerts extends Component {
    componentDidMount() {
        document.title = "Damatrà - Prossimi Concerti";
        const description = "Rimani sempre aggiornato sui nostri concerti e vieni a ballare con noi i balli folk più coinvolgenti";
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        if (window.location.hash === '')
            OnPageLoaded(true, true);
        else
            OnPageLoaded(true, false);
    }

    render() {
        let now = new Date();
        return (
            <div>
                <PageTitle title="Concerti" bgimgurl="/img/titlebg/concerti.jpg"></PageTitle>
                <div className="container">
                    {
                        concerts.map((concert) =>
                            new Date(concert.enddatetime) > now && <Event key={concert.id} event={concert}></Event>
                        )
                    }
                    <div className="row pt-4">
                        <div className="col-12 text-center">
                            <Link className="btn btn-outline-primary primary-btn" target="_blank" to={{ pathname: "https://www.facebook.com/DamatraFolkBand/events" }}>Visualizza i nostri eventi su Facebook</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Concerts;


// WEBPACK FOOTER //
// ./src/pages/Concerts.js